module.exports = __webpack_public_path__ + "display/static/img/icon-b.d70663d.svg";


//////////////////
// WEBPACK FOOTER
// ./~/tui-image-editor/dist/svg/icon-b.svg
// module id = 772
// module chunks = 1 3